<template>
  <div>

    <b-card
      class="business-card"
    >

      <section id="faq-tabs">
        <b-tabs
          vertical
          content-class="col-12 col-md-8 col-lg-9"
          pills
          nav-wrapper-class="faq-navigation col-md-4 col-lg-3 col-12"
          nav-class="nav-left"
        >

          <!-- configuration tab -->
          <b-tab
            v-for="(item, index) in configurationsOptions"
            :key="item.name"
            :active="!index"
          >

            <!-- title -->
            <template #title>
              <feather-icon
                :icon="item.icon"
                size="18"
                class="mr-1"
              />
              <span class="font-weight-bold">{{ item.name }}</span>
            </template>

            <!-- <item.component /> -->
            <component :is="item.component" />
          </b-tab>
        <!--/ payment tab -->

        </b-tabs>
      </section>
    </b-card>
    <!--/ configuration tabs pills -->

  </div>
</template>

<script>
import {
  BCard, BTabs, BTab,
} from 'bootstrap-vue'
import AccountTierLevelConfiguration from './AccountTierLevelConfiguration.vue'
import CorporateInformation from './CorporateInformation.vue'
import EODConfiguration from './EODConfiguration.vue'
import InterestInformation from './InterestInformation.vue'
import OtherConfiguration from './OtherConfiguration.vue'
import PublicHolidayConfiguration from './PublicHolidayConfiguration.vue'
import TaxInformation from './TaxInformation.vue'
import WorkingDayConfiguration from './WorkingDayConfiguration.vue'
import InstitutionFileUpload from './InstitutionFileUpload.vue'
import CashHandlingLimit from './CashHandlingLimit.vue'
import ThresholdConfiguration from './ThresholdConfiguration.vue'
import CentralWebhookConfig from './CentralWebhookConfig.vue'

export default {
  components: {
    BCard,
    BTabs,
    BTab,
    AccountTierLevelConfiguration,
    CorporateInformation,
    EODConfiguration,
    InterestInformation,
    OtherConfiguration,
    PublicHolidayConfiguration,
    TaxInformation,
    ThresholdConfiguration,
    WorkingDayConfiguration,
    InstitutionFileUpload,
    CashHandlingLimit,
    CentralWebhookConfig,
  },
  data() {
    return {
      configurations: [
        {
          name: 'Account Tier Level',
          icon: 'CreditCardIcon',
          component: AccountTierLevelConfiguration,
        },
        {
          name: 'Cash Handling Limit',
          icon: 'PauseCircleIcon',
          component: CashHandlingLimit,
        },
        {
          name: 'Central Webhook Config',
          icon: 'AnchorIcon',
          component: CentralWebhookConfig,
        },
        {
          name: 'Corporate Information',
          icon: 'UserIcon',
          component: CorporateInformation,
        },
        {
          name: 'EOD Configuration',
          icon: 'RefreshCwIcon',
          component: EODConfiguration,
        },
        {
          name: 'Institution Identity',
          icon: 'UploadIcon',
          component: InstitutionFileUpload,
        },
        {
          name: 'Interest Information',
          icon: 'PercentIcon',
          component: InterestInformation,
        },
        {
          name: 'Other Configurations',
          icon: 'SettingsIcon',
          component: OtherConfiguration,
        },
        {
          name: 'Public Holiday',
          icon: 'CalendarIcon',
          component: PublicHolidayConfiguration,
        },
        {
          name: 'Tax Information',
          icon: 'TrendingUpIcon',
          component: TaxInformation,
        },
        {
          name: 'Threshold Configuration',
          icon: 'BarChart2Icon',
          component: ThresholdConfiguration,
        },
        {
          name: 'Working Day',
          icon: 'CalendarIcon',
          component: WorkingDayConfiguration,
        },
      ],
    }
  },
  computed: {
    configurationsOptions() {
      return this.configurations.map(item => ({
        ...item,
        name: this.$t(item.name),
      }))
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-faq.scss';
</style>
